import React, { cloneElement } from 'react';
import { MessageSquareIcon, CloudIcon, ZapIcon, ShieldIcon, ServerIcon, ClockIcon } from 'lucide-react';
const TelecomsSolution = () => {
  const userJourneySteps = [{
    title: 'Free Trial Access',
    description: 'Every user experiences AI capabilities before committing to a subscription',
    icon: <MessageSquareIcon className="h-6 w-6" data-id="element-483" />
  }, {
    title: 'Seamless Subscription',
    description: 'Integration with existing telecom billing and renewal systems',
    icon: <ZapIcon className="h-6 w-6" data-id="element-484" />
  }, {
    title: 'Instant Activation',
    description: 'Frictionless experience across all devices from day one',
    icon: <ClockIcon className="h-6 w-6" data-id="element-485" />
  }];
  const integrationFeatures = [{
    title: 'Minimal Latency',
    description: 'Real-time interaction for seamless conversational experience',
    icon: <ZapIcon className="h-6 w-6 text-[#54d4cb]" data-id="element-486" />
  }, {
    title: 'Full Control',
    description: 'Operators retain complete control over subscriptions, payments, and data',
    icon: <ShieldIcon className="h-6 w-6 text-[#54d4cb]" data-id="element-487" />
  }, {
    title: 'Scalable Deployment',
    description: 'Built to serve millions of users simultaneously',
    icon: <ServerIcon className="h-6 w-6 text-[#54d4cb]" data-id="element-488" />
  }];
  return <>
      {/* How It Works Section */}
      <section className="py-16 bg-white" data-id="element-489">
        <div className="container mx-auto px-4" data-id="element-490">
          <div className="max-w-4xl mx-auto" data-id="element-491">
            <h2 className="text-3xl font-bold text-center mb-8" data-id="element-492">
              How It Works
            </h2>
            <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-493">
              <p className="text-lg text-gray-700 mb-6" data-id="element-494">
                Subscribers interact through a dedicated short code or USSD
                entry point. Messages are routed through the operator's network
                to a cloud-based AI engine that returns conversational responses
                instantly.
              </p>
              <p className="text-lg text-gray-700" data-id="element-495">
                Operators retain full control over billing, pricing, and
                lifecycle management while the AI engine handles message logic,
                language processing, and response generation.
              </p>
            </div>
            <div className="mb-12" data-id="element-496">
              <h3 className="text-2xl font-semibold mb-6 text-center" data-id="element-497">
                Simple User Journey
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-498">
                {userJourneySteps.map((step, index) => <div key={index} className="bg-white border-2 border-[#54d4cb] rounded-lg p-6" data-id="element-499">
                    <div className="bg-[#e5f8f7] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-500">
                      {cloneElement(step.icon, {
                    className: 'h-6 w-6 text-[#54d4cb]'
                  })}
                    </div>
                    <h4 className="text-xl font-semibold mb-2" data-id="element-501">{step.title}</h4>
                    <p className="text-gray-600" data-id="element-502">{step.description}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Integration Model Section */}
      <section className="py-16 bg-gray-50" data-id="element-503">
        <div className="container mx-auto px-4" data-id="element-504">
          <div className="max-w-4xl mx-auto" data-id="element-505">
            <div className="text-center mb-12" data-id="element-506">
              <h2 className="text-3xl font-bold mb-4" data-id="element-507">Integration Model</h2>
              <p className="text-xl text-gray-600" data-id="element-508">
                Seamless integration with your core telecom infrastructure
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-509">
              <div className="flex items-start mb-6" data-id="element-510">
                <div className="bg-[#e5f8f7] p-3 rounded-full mr-4 flex-shrink-0" data-id="element-511">
                  <CloudIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-512" />
                </div>
                <div data-id="element-513">
                  <p className="text-lg text-gray-700" data-id="element-514">
                    The platform integrates directly with your core systems and
                    messaging infrastructure, connecting securely to a
                    cloud-hosted AI engine.
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-515">
              {integrationFeatures.map((feature, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6" data-id="element-516">
                  <div className="mb-4" data-id="element-517">{feature.icon}</div>
                  <h3 className="text-xl font-semibold mb-2" data-id="element-518">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-519">{feature.description}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default TelecomsSolution;